export const TRANSACTION_LOADING = "TRANSACTION_LOADING";
export const TRANSACTION_RESET = "TRANSACTION_RESET";
export const GET_TRANSACTION = "GET_TRANSACTION";
export const GET_TRANSACTION_ONE = "GET_TRANSACTION_ONE";
export const GET_TRANSACTION_SUCCESS = "GET_TRANSACTION_SUCCESS";
export const GET_TRANSACTION_FAIL = "GET_TRANSACTION_FAIL";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION"
export const DELETE_TRANSACTION_SUCCESS = "DELETE_TRANSACTION_SUCCESS"
export const DELETE_TRANSACTION_FAIL = "DELETE_TRANSACTION_FAIL"
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION"
export const UPDATE_TRANSACTION_SUCCESS = "UPDATE_TRANSACTION_SUCCESS"
export const UPDATE_TRANSACTION_FAIL = "UPDATE_TRANSACTION_FAIL"
export const ADD_NEW_TRANSACTION = "ADD_NEW_TRANSACTION"
export const ADD_TRANSACTION_SUCCESS = "ADD_TRANSACTION_SUCCESS"
export const ADD_TRANSACTION_FAIL = "ADD_TRANSACTION_FAIL"
export const TRANSACTION_RESET_CREATE = "TRANSACTION_RESET_CREATE"